import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || 'https://azad.ntssoftweb.com/api/v1';

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// ── Request: attach token + active branch ────────────────
api.interceptors.request.use(
  (config) => {
    try {
      const raw = localStorage.getItem('auth-v2');
      if (raw) {
        const state = JSON.parse(raw)?.state || {};
        if (state.token) {
          config.headers.Authorization = `Bearer ${state.token}`;
        }
        if (state.activeBranch?._id) {
          config.headers['X-Branch-Id'] = state.activeBranch._id;
        }
      }
    } catch {}
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Response: global error handling ─────────────────────
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const msg = error.response?.data?.message || 'خطای شبکه';

    if (error.response?.status === 401) {
      localStorage.removeItem('auth-v2');
      window.location.href = '/login';
      return;
    }

    if (error.response?.status !== 404) {
      toast.error(msg);
    }

    return Promise.reject(error.response?.data || error);
  }
);

export default api;
